import './styles/index.scss'

import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
// Route chunks load lazily, so without this eager import the WhatsApp entry
// marker (utm_medium=whatsapp → sessionStorage) would only be captured after
// login has already stripped the query params. Importing here pulls the
// capture into the entry chunk, running it on the very first URL.
import { captureWhatsAppEntry } from './libs/utils/browser'
import { initGA } from './libs/analytics/analytics'
import { tokenStore } from './services/tokenStore'
import { useAppStore } from './context/useAppStore'
import { useBasketStore } from './context/useBasketStore'
import { useContentChannelStore } from './context/useContentChannelStore'
import useEventStore from './context/useEventStore'
import useExistingBookingStore from './context/useExistingBookingStore'
import { useFullScreenContentStore } from './context/useFullScreenContentStore'
import { useMeetTheCastStore } from './context/useMeetTheCastStore'
import { useTicketsStore } from './context/useTicketsStore'
import { useUserStore } from './context/useUserStore'
import { useSeatMapFilterStore } from './context/useSeatMapFilterStore'

// Must run on the very first URL, before the router/login can strip params
captureWhatsAppEntry()
// Boot GA immediately (Consent Mode v2, default denied) so the landing
// page_view and pre-consent events are captured; consent only gates storage.
initGA()

if ((window as any).__PLAYWRIGHT__) {
  ;(window as any).stores = {
    appStore: useAppStore,
    userStore: useUserStore,
    walletStore: useTicketsStore,
    basketStore: useBasketStore,
    eventStore: useEventStore,
    existingBookingStore: useExistingBookingStore,
    contentChannelStore: useContentChannelStore,
    meetTheCastStore: useMeetTheCastStore,
    fullScreenStore: useFullScreenContentStore,
    seatMapFilterStore: useSeatMapFilterStore,
  }
}

const params = new URLSearchParams(window.location.search)

if (params.get('debug') === '1') {
  const script = document.createElement('script')
  script.src = 'https://cdn.jsdelivr.net/npm/eruda'
  script.onload = () => (window as any).eruda?.init()
  document.head.appendChild(script)
}

const i = params.get('i')
const isPreview = window.location.pathname === '/preview'

if (!isPreview) {
  localStorage.removeItem('iframe_mode')
  localStorage.removeItem('channel_uid')
  localStorage.removeItem('categories')
  localStorage.removeItem('sref')
}

if (isPreview) {
  ;(window as any).__previewChannel = params.get('channel_uid')

  // Scales the rem-based type scale down for the console's preview iframe
  document.documentElement.dataset.preview = 'true'

  const channelUid = params.get('channel_uid')
  const categories = params.get('categories')
  const sref = params.get('sref')

  localStorage.removeItem('user')

  if (i) tokenStore.set(i)

  localStorage.setItem('iframe_mode', 'true')
  localStorage.setItem('channel_uid', channelUid ?? '')
  localStorage.setItem('categories', categories ?? '')
  localStorage.setItem('sref', sref ?? '')

  const previewUser = { email: '', preferences_required: false }
  localStorage.setItem('user', JSON.stringify(previewUser))
  // Sync the store immediately so user is non-null before App renders,
  // preventing PublicRoutes from redirecting /preview to /login.
  useUserStore.setState({ user: previewUser as any })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <BrowserRouter
    future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
  >
    {/* <StrictMode> */}
    <App />
    {/* </StrictMode> */}
  </BrowserRouter>,
)
